(ns bleene.layout.core
  (:require
   [bleene.layout.panes-manager :refer [panes-manager]]
   [bleene.layout.events]))

(defn base-page []
  [:div {:class "flex flex-col h-screen"}
   [:div {:class "grow"}
    [:f> panes-manager]]])
